import { Box } from '@mui/material';
import { memo } from 'react';

function Passed() {
  return (
    <Box data-testid="passed" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 64 64" id="pdf">
        <path fill="#80d8ff" d="M10 34h30v16H10z" />
        <path
          fill="#01579b"
          d="M56 18.75a.37.37 0 0 0 0-.14 1 1 0 0 0-.21-.32l-14-14a1 1 0 0 0-.32-.21.37.37 0 0 0-.14 0A.69.69 0 0 0 41 4H13a1 1 0 0 0-1 1v27H9a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h3v7a1 1 0 0 0 1 1h42a1 1 0 0 0 1-1V19a.69.69 0 0 0 0-.25ZM42 7.41 52.59 18H42ZM10 34h30v16H10Zm4 24v-6h27a1 1 0 0 0 1-1V33a1 1 0 0 0-1-1H14V6h26v13a1 1 0 0 0 1 1h13v38Z"
        />
        <path fill="#fff" d="M52.59 18H42V7.41L52.59 18z" />
        <path fill="#fff" d="M54 20v38H14v-6h27a1 1 0 0 0 1-1V33a1 1 0 0 0-1-1H14V6h26v13a1 1 0 0 0 1 1Z" />
        <path
          fill="#01579b"
          d="M15 46v-8h2.66a2.8 2.8 0 0 1 1.9.58 2.42 2.42 0 0 1 .83 1.92 2.54 2.54 0 0 1-.39 1.32 2.19 2.19 0 0 1-1 .88 2.67 2.67 0 0 1-1.15.23h-1.2V46zm1.69-4.52h.94a1.14 1.14 0 0 0 .81-.28 1 1 0 0 0 .29-.76q0-.92-1.1-.92h-.94zM21.95 46v-8h3a3.18 3.18 0 0 1 2.08.68A4 4 0 0 1 28.5 42a4.48 4.48 0 0 1-.5 2.11 3.52 3.52 0 0 1-1.4 1.45 4.54 4.54 0 0 1-2.22.44zm1.69-1.52h1.08a1.93 1.93 0 0 0 1.09-.29 2.53 2.53 0 0 0 1-2.26 2.4 2.4 0 0 0-.95-2.12 1.87 1.87 0 0 0-1.08-.29h-1.14zm6.6 1.52v-8h4.58v1.52h-2.89v1.63h2.65v1.52h-2.65V46z"
        />
      </svg>
    </Box>
  );
}

export default memo(Passed);
